module.exports = __webpack_public_path__ + "img/p4_3.d1a16939.png";